<template>
  <img src="@/assets/images/logos/company-logo-qaj-service.webp"/>
</template>
<script setup>

</script>